/* One arrow for the whole app.
   The text glyph "→" renders differently on every platform: small, thin and
   sitting below the text baseline in Android's Roboto, a different shape again
   on iOS. An inline SVG sized in em looks the same everywhere and follows the
   surrounding font size and colour. */
export function ArrowIcon({ className = "" }) {
  return (
    <svg className={`tx-arrow ${className}`.trim()} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}

/* Replaces "→" inside ops-written or data-built strings ("BLR → DEL") with
   the SVG arrow, so admin copy gets the same arrow as the code. */
export function withArrows(text) {
  if (typeof text !== "string" || !text.includes("→")) return text;
  const parts = text.split("→");
  return parts.flatMap((part, i) =>
    i === 0 ? [part] : [<ArrowIcon key={i} className="tx-arrow--inline" />, part]);
}
